module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-8-svgrepo-com.88f81c88.svg";